/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthPlatformRemotePatient
 */
export interface PalAuthPlatformRemotePatient {
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    middle_initial?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    member_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    contract_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    medicare_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    eligibility?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    end_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthPlatformRemotePatient
     */
    not_managed_by_portal?: boolean;
    /**
     *
     * @type {string}
     * @memberof PalAuthPlatformRemotePatient
     */
    platform_message?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof PalAuthPlatformRemotePatient
     */
    required_additional_categories?: Array<string>;
}

/**
 * Check if a given object implements the PalAuthPlatformRemotePatient interface.
 */
export function instanceOfPalAuthPlatformRemotePatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthPlatformRemotePatientFromJSON(json: any): PalAuthPlatformRemotePatient {
    return PalAuthPlatformRemotePatientFromJSONTyped(json, false);
}

export function PalAuthPlatformRemotePatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthPlatformRemotePatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'middle_initial': !exists(json, 'middle_initial') ? undefined : json['middle_initial'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'member_number': !exists(json, 'member_number') ? undefined : json['member_number'],
        'contract_name': !exists(json, 'contract_name') ? undefined : json['contract_name'],
        'medicare_id': !exists(json, 'medicare_id') ? undefined : json['medicare_id'],
        'eligibility': !exists(json, 'eligibility') ? undefined : json['eligibility'],
        'start_date': !exists(json, 'start_date') ? undefined : json['start_date'],
        'end_date': !exists(json, 'end_date') ? undefined : json['end_date'],
        'not_managed_by_portal': !exists(json, 'not_managed_by_portal') ? undefined : json['not_managed_by_portal'],
        'platform_message': !exists(json, 'platform_message') ? undefined : json['platform_message'],
        'required_additional_categories': !exists(json, 'required_additional_categories') ? undefined : json['required_additional_categories'],
    };
}

export function PalAuthPlatformRemotePatientToJSON(value?: PalAuthPlatformRemotePatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'middle_initial': value.middle_initial,
        'last_name': value.last_name,
        'dob': value.dob,
        'member_number': value.member_number,
        'contract_name': value.contract_name,
        'medicare_id': value.medicare_id,
        'eligibility': value.eligibility,
        'start_date': value.start_date,
        'end_date': value.end_date,
        'not_managed_by_portal': value.not_managed_by_portal,
        'platform_message': value.platform_message,
        'required_additional_categories': value.required_additional_categories,
    };
}

